import LegalPage from "@/components/LegalPage";
import { CONTACT_EMAIL, CONSULTATION_PRICE } from "@/lib/config";

export default function Terms() {
    return (
        <LegalPage
            testId="terms-page"
            eyebrow="Legal"
            title="Terms & Conditions"
            updated="June 2026"
            seoTitle="Terms & Conditions · Abhijit J K"
            seoDescription="Terms and conditions governing paid business consultation services provided by Abhijit J K, Founder of Ragi Media."
            intro="These Terms & Conditions govern your use of this website and the paid consultation services offered by Abhijit J K (Founder, Ragi Media), Bengaluru, India. By booking a consultation or using this website, you agree to these terms."
            sections={[
                {
                    heading: "Services",
                    body: `We provide a paid, one-to-one business strategy consultation of approximately 60 minutes, delivered online via Google Meet. The consultation includes business review, brand and digital presence guidance, and a practical growth roadmap. The current consultation fee is ${CONSULTATION_PRICE} (inclusive of applicable taxes unless stated otherwise).`,
                },
                {
                    heading: "Bookings & Payments",
                    list: [
                        "Payment is required in advance to confirm and reserve your consultation seat.",
                        "Payments are processed securely through Razorpay. We do not store your card or banking details.",
                        "After successful payment, you select an available slot via our scheduling calendar (Calendly).",
                        "You will receive a confirmation and meeting link by email and/or WhatsApp.",
                    ],
                },
                {
                    heading: "Your Responsibilities",
                    list: [
                        "Provide accurate business and contact information at the time of booking.",
                        "Join the session on time using the meeting link provided.",
                        "Keep relevant business details (website, social pages, current challenges) ready before the session.",
                    ],
                },
                {
                    heading: "Rescheduling & Cancellations",
                    body: "Rescheduling and cancellations are governed by our Refund & Cancellation Policy. Please review it before booking.",
                },
                {
                    heading: "No Guarantee of Results",
                    body: "Our consultation provides professional guidance and recommendations based on experience. Business outcomes depend on many factors outside our control, including your own execution. We do not guarantee any specific revenue, growth, or business result.",
                },
                {
                    heading: "Intellectual Property",
                    body: "All content on this website, and any frameworks, materials, or recommendations shared during the consultation, are intended for your own business use and may not be resold, redistributed, or republished without written permission.",
                },
                {
                    heading: "Limitation of Liability",
                    body: "To the maximum extent permitted by law, Abhijit J K and Ragi Media shall not be liable for any indirect, incidental, or consequential losses arising from the use of our website or services. Our total liability for any claim shall not exceed the amount you paid for the relevant consultation.",
                },
                {
                    heading: "Governing Law",
                    body: "These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Bengaluru, Karnataka.",
                },
                {
                    heading: "Contact",
                    body: `For any questions about these Terms & Conditions, contact us at ${CONTACT_EMAIL}.`,
                },
            ]}
        />
    );
}
